// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--confluence-whiteboards/ct-changeboarding-message';

import { MessageFrontend as createMessageFrontendConfluenceWhiteboardsChangeboardingExperiences } from '@post-office/browser--confluence-whiteboards/confluence-whiteboards-changeboarding-experiences/placements/in-app-v2/ct-changeboarding-message';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type RenderProps } from '@post-office/browser--confluence-whiteboards/ct-changeboarding-message';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendConfluenceWhiteboardsChangeboardingExperiences({
		messageTemplateId: 'confluence-whiteboards-changeboarding-experiences',
	}),
];

export const RawPlacement: PlacementRendererStage<RenderProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<RenderProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<RenderProps> = RawPlacement;
